import {apiUrl} from '../../utils/constants';
import {GET} from '../api.service.wrapper';

export const GetDashboard = async (params) => {
    const response = await GET(apiUrl.dashboard, params);
    return response;
}

